// This is src/components/SideMenu.js
import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import './SideMenu.css';
                                
import { FaBookOpen, FaChartLine, FaRegStar, FaChartBar, FaSearch, FaTrophy, FaFileInvoiceDollar } from 'react-icons/fa';
import { AiOutlineMenuFold, AiOutlineMenuUnfold } from 'react-icons/ai';

export default function SideMenu() {
  const [collapsed, setCollapsed] = useState(false);

  const menuItems = [
    { to: '/', label: 'Top Stocks', Icon: FaTrophy },
    { to: '/visualization', label: 'Stock Visualization', Icon: FaChartBar },
    { to: '/ratio-visualization', label: 'Stock Ratio Visualization', Icon: FaChartBar },
  { to: '/comparison', label: 'Stock Comparison', Icon: FaChartLine },
  { to: '/watchlist', label: 'Stock Watchlist', Icon: FaRegStar },
  { to: '/screener', label: 'Stock Screener', Icon: FaSearch },
  { to: '/income-statement', label: 'Income Statement', Icon: FaFileInvoiceDollar },
  { to: '/data-dictionary', label: 'Data and API Documentation', Icon: FaBookOpen },

  
  ];

  return (
    <nav className={`sidemenu ${collapsed ? 'collapsed' : ''}`} aria-label="Primary navigation">
      

                                      <button
                                      className="collapse-button"
                                      type="button"
                                      onClick={() => setCollapsed(current => !current)}
                                      aria-label={collapsed ? 'Expand menu' : 'Collapse menu'}
                                      aria-expanded={!collapsed}
                                      aria-controls="primary-navigation-links"
                                      >
                                      {collapsed
                                        ? <AiOutlineMenuUnfold aria-hidden="true" focusable="false" />
                                        : <AiOutlineMenuFold aria-hidden="true" focusable="false" />}
                                      </button>
                                      <h2 className="sidemenu-title"> </h2>



      <ul className="sidemenu-list" id="primary-navigation-links">
              {menuItems.map(({ to, label, Icon }) => (
          <li key={to}>
            <NavLink
              to={to}
              end={to === '/'}
              aria-label={collapsed ? label : undefined}
              title={collapsed ? label : undefined}
              className={({ isActive }) =>
                isActive ? 'sidemenu-link active' : 'sidemenu-link'
              }
            >
              <Icon className="sidemenu-icon" aria-hidden="true" focusable="false" />
              <span className="sidemenu-text">{label}</span>
            </NavLink>
          </li>
        ))}
      </ul>

    </nav>
  );
}
